import { gql } from '@apollo/client';

export const GENERATE_PARTNER_FILES_EXECUTED = gql`
  subscription GeneratePartnerFilesExecuted($userId: Int!) {
    generatePartnerFilesExecuted(userId: $userId) {
      unprocessedPartners
    }
  }
`;
